"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CallCenter;

var _CallCenter = require("@adobe/react-spectrum-workflow/dist/CallCenter");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CallCenter(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_CallCenter.A4uCallCenter, null));
}